import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["mortgage-type"],
  _excluded2 = ["totalLoanAmount", "mortgageType", "netRate"];
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DatatableEventsHandler from "@Shared/utils/application-mixins/data-table-events-mixin";
import SubmissionHistoryHandler from "@Shared/utils/application-mixins/submission-history-mixin";
import { mapState, mapGetters } from "vuex";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { capitalize } from "lodash";
import { CURRENT_APPLICATION } from "../../../../store/application-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationsTable",
  components: {
    SimpleButton
  },
  mixins: [DatatableEventsHandler, SubmissionHistoryHandler],
  props: {
    selectedType: {
      type: String,
      default: ""
    },
    printing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      applicationColumns: ["select", "mortgageType", "loanAmount", "rate", "lineOfBusiness", "download"],
      selectedMortgageToPrint: ""
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("ApplicationStore", ["calculatedValues"])), mapGetters("ApplicationStore", ["getSubmissionHistory", CURRENT_APPLICATION])), {}, {
    printingEnabled() {
      const submissionHistories = this.getSubmissionHistory.byId;
      return this.validSubmissionExist(submissionHistories);
    },
    options() {
      return {
        filterable: false,
        sortable: [],
        columns: ["mortgageType", "loanAmount", "rate", "lineOfBusiness"],
        headings: {
          select: this.$t("global.words.select"),
          mortgageType: this.$t("application-flow.labels.mortgageType"),
          loanAmount: this.$t("direct-to-lender.lenderSubmit.loanAmount"),
          rate: this.$t("direct-to-lender.lenderSubmit.rate"),
          lineOfBusiness: this.$t("direct-to-lender.lenderSubmit.lineOfBusiness"),
          download: this.$t("global.words.download")
        },
        skin: "table table-hover",
        columnsClasses: {
          select: "hidden-heading",
          actions: "w-25 hidden-heading"
        }
      };
    },
    applications() {
      const {
        mortgageValues
      } = this.calculatedValues;
      const mortgageSubmissionDetails = this.CURRENT_APPLICATION["submission-details"];
      const submissionDetails = _reduceInstanceProperty(mortgageSubmissionDetails).call(mortgageSubmissionDetails, (acc, _ref) => {
        let {
            "submission-details": {
              "mortgage-type": mortgageType
            }
          } = _ref,
          values = _objectWithoutProperties(_ref["submission-details"], _excluded);
        acc[mortgageType] = values;
        return acc;
      }, {});
      return _mapInstanceProperty(mortgageValues).call(mortgageValues, _ref2 => {
        let {
            totalLoanAmount,
            mortgageType,
            netRate
          } = _ref2,
          res = _objectWithoutProperties(_ref2, _excluded2);
        const lineOfBusiness = capitalize(submissionDetails[mortgageType]["line-of-business"]);
        return {
          mortgageType,
          loanAmount: this.$options.filters.formatMoneyValue(totalLoanAmount),
          rate: netRate ? `${_parseFloat(netRate).toFixed(3)}%` : 0,
          lineOfBusiness,
          data: _objectSpread({
            totalLoanAmount,
            mortgageType,
            netRate,
            lineOfBusiness
          }, res)
        };
      });
    }
  }),
  methods: {
    pdfButtonLoading(mortgageType) {
      return this.printing && this.selectedMortgageToPrint === mortgageType;
    },
    handleSelect({
      data
    }) {
      this.$emit("select", data);
    },
    handleDownload({
      data
    }) {
      this.selectedMortgageToPrint = data.mortgageType;
      this.$emit("application-pdf", data);
    }
  }
});